import $ from 'jquery';

/**
 * Check Javascript required fields
 */
class RequiredSubmitCheck {
    constructor() {
        this.$jsRequired = $('.js-required');

        // Add required icons to fields
        this.addRequiredIcons();

        $(document).on('click', '.js-required-submit', () => {
            // Update required fields variable. (DOM might have changed).
            this.$jsRequired = $('.js-required');

            // Get visible required fields.
            const $visibleRequiredFields = this.$jsRequired.filter(':visible');
            let emptyFound = false;

            $visibleRequiredFields.each(function () {
                if (!$(this).find('input, select').val() && !$(this).find('input').is(':checked')) {
                    emptyFound = true;
                    $(this).addClass('has-required-warning');
                } else {
                    $(this).removeClass('has-required-warning');
                }
            });

            if (emptyFound) {
                alert('Please complete all required fields.');

                return false;
            }

            // We need to unlock checkbox fields before submitting otherwise they don't have a value.
            $('.js-unlock-target input[type=checkbox]').removeAttr('disabled');

            return true;
        });
    }

    addRequiredIcons() {
        // Add required icons to fields
        this.$jsRequired.each(function () {
            if ($(this).find('label span.o-form__required-icon').length < 1) {
                $(this).find('label').append('<span class="o-form__required-icon js-required-icon">(Required)</span>');
            }
        });
    }
}

export default RequiredSubmitCheck;
